import React from 'react';
import ReactDOM from 'react-dom';
import Model from '@tripian/model';
import classes from './KiwiVisaBenefitsModal.scss';

interface IKiwiVisaBenefitsModal {
  onClose: () => void;
  t: (value: Model.TranslationKey) => string;
}

const BENEFITS = [
  'Best available rate guarantee',
  'Automatic room upgrade upon arrival, when available',
  'Complimentary in-room Wi-Fi, when available',
  'Complimentary breakfast for two',
  '$25 USD food or beverage credit',
  'VIP Guest status',
  'Late check-out upon request, when available',
];

const KiwiVisaBenefitsModal: React.FC<IKiwiVisaBenefitsModal> = ({ onClose, t }) =>
  ReactDOM.createPortal(
    <div className={classes.overlay} onClick={(e) => { e.stopPropagation(); onClose(); }} role="presentation">
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className={classes.modal} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className={classes.header}>
          <div className={classes.headerLeft}>
            <span className={classes.visaLogo} />
            <span className={classes.title}>{t('kiwi.visaBenefits.title')}</span>
          </div>
          <button type="button" className={classes.closeBtn} onClick={onClose}>
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </div>

        {/* Description */}
        <p className={classes.description}>{t('kiwi.visaBenefits.description')}</p>

        {/* Benefits list */}
        <ul className={classes.benefitsList}>
          {BENEFITS.map((benefit) => (
            <li key={benefit} className={classes.benefitItem}>
              <svg className={classes.checkIcon} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="12" fill="#1a1f71" />
                <path d="M9.5 15.5l-3-3 1.41-1.41L9.5 12.67l5.59-5.59L16.5 8.5z" fill="#fff" />
              </svg>
              <span>{benefit}</span>
            </li>
          ))}
        </ul>

        {/* Footer link */}
        <a className={classes.termsLink} href="https://www.visasignaturehotels.com/about/benefits" target="_blank" rel="noopener noreferrer">{t('kiwi.visaBenefits.termsAndConditions')}</a>
      </div>
    </div>,
    document.body,
  );

export default KiwiVisaBenefitsModal;